
import { Component, Mixins, Prop } from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import NewFormWrapper from "@/components/NewFormWrapper.vue";
import Crypto from "crypto";

@Component({
  components: { NewFormWrapper, DeleteDialog }
})
export default class DayanakList extends Mixins(SimpleInputMixin) {
  showPreview = false;
  previewData = "";
  selectedFiles: Array<File> = [];
  loadingPreview: boolean = false;

  headers = [
    { text: 'Evrak Adı', value: 'name' },
    { text: 'İşlemler', value: 'actions', sortable: false, width: '100' }
  ]

  deleteDayanak(index: number) {
    this.localValue.splice(index, 1);
  }

  fileRule(dosyalar: Array<File>) {
    if (dosyalar && dosyalar.length > 0) {
      for (const dosya of dosyalar) {
        let uzanti = dosya.name.split('.').pop()?.toLowerCase();
        if (["udf", "pdf", "jpg", "jpeg", "png", "tif", "tiff", "UDF", "PDF", "JPG", "JPEG", "PNG", "TIF", "TIFF"].indexOf(uzanti ?? '') >= 0) {
          if (dosya.size < 10485760)
            return true;
          else
            return "Doküman boyutu 10MB'dan fazla olamaz.";
        } else
          return "Doküman formatı UYAP'a uygun değil."
      }
    } else {
      return 'Lütfen bu alanı doldurun.';
    }
  }

  async handleFileChange(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (files) {
      this.selectedFiles = Array.from(files);
      await this.uploadDayanak(this.selectedFiles);
    }
  }

  async uploadDayanak(files: File[]) {
    if (!files || files.length === 0) return;

    let filesValue: Array<{ data: string, name: string, mimeType: string, dosya: File | null, hash: string | null }> = [];

    for (const file of files) {
      // Dosya boyutu kontrolü (10 MB)
      if (file.size > 10 * 1024 * 1024) {
        this.$toast?.error(`"${file.name}" dosyası 10MB'den büyük, yüklenemez.`);
        continue; // bu dosyayı atla
      }

      let base64File: any = await this.$helper.convertToBase64(file);
      let hash = Crypto.createHash('sha1')
          .update((base64File.split(','))[1])
          .digest()
          .toString('hex');

      let fileValue = {
        data: (base64File.split(','))[1],
        name: file.name,
        mimeType: file.type,
        dosya: file,
        hash: hash,
      };

      filesValue.push(fileValue);
    }

    if (filesValue.length > 0) {
      this.addDayanak(filesValue);
    }

    this.selectedFiles = []; // yükleme sonrası temizle
  }


  addDayanak(dayanaklar: Array<any>) {
    dayanaklar.forEach(dayanak => {
      this.localValue.push(dayanak);
    });
    this.input();
  }

  converB64Data(item: any): string {
    return 'data:' + item.mimeType + ';base64,' + item.data;
  }

  async viewDocument(item: any) {
    if (!item.data && item.file_path) {
      try {
        this.loadingPreview = true;
        item.dosya = await this.$helper.getBlobFromLink(
            '/api/v1/file/download/' + item.file_path.replace('uploads/', '')
        );
        item.mimeType = item.dosya.type;
        let base64: any = await this.$helper.convertToBase64(item.dosya);
        item.data = (base64.split(','))[1];
        this.input();
      } catch (error) {
        this.$toast?.error('Dosya yüklenirken hata oluştu');
        return;
      } finally {
        this.loadingPreview = false;
      }
    }
    this.previewData = this.converB64Data(item);
    this.showPreview = true;
  }
}
